import { POLYGON_RANGE } from 'Pods/SearchPage/Store/constants'

export const PAGE_VERSION = 'v2'

// GrowthBook feature that serves this page as an A/B test (see SharedHelper#new_search_page?).
export const EXPERIMENT_KEY = 'new_search_page'

export const EVENT_SOURCE = {
  FILTER_BAR: 'filter bar',
  SECONDARY_BAR: 'secondary bar',
  MOBILE_MENU: 'mobile menu',
  TAGS: 'tags',
  PAGINATION: 'pagination',
  MODEL_CARD: 'model card',
}

export const FILTER_NAME = {
  PRODUCT_TYPE_TOGGLE: 'product_type_toggle',
  STYLE: 'style',
  POLY_COUNT: 'poly_count',
  TAGS: 'tags',
  DATE_PUBLISHED: 'date_published',
  LICENSE: 'license',
  PRICE: 'price',
  FILE_FORMAT: 'file_format',
  DESIGNER: 'designer',
  QUALITY: 'quality',
  CONTENT_SOURCE: 'content_source',
  SORT_BY: 'sort_by',
  PAGE: 'page',
  PER_PAGE: 'per_page',
  CATEGORY: 'category',
  WITHIN_KEYWORDS: 'within_keywords',
  ADVANCED: 'advanced',
  PERSONAL: 'personal',
  PURCHASES: 'purchases',
}

// Boolean filters (animated, rigged, pbr, ...) report their own name with this value.
export const BOOLEAN_FILTER_VALUE = '1'

// Feature toggles report their own name, except low poly, which is a Poly count range.
export const getFeatureFilter = (featureKey) => (
  featureKey === 'low_poly'
    ? { name: FILTER_NAME.POLY_COUNT, value: POLYGON_RANGE.LOW_POLY }
    : { name: featureKey, value: BOOLEAN_FILTER_VALUE }
)
